import React from "react";

function ManufIcon() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M54.4539 38.0624L55.1247 8.66237C55.1247 7.96237 55.6789 7.4082 56.3789 7.4082H63.3497C64.0497 7.4082 64.5747 7.96237 64.6039 8.66237L65.858 62.5915H57.9247"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.3875 36.4285L47.775 13.3576C47.775 12.8326 47.3375 12.4243 46.8416 12.4243H41.6208C41.0958 12.4243 40.6875 12.8618 40.6875 13.3576L40.1333 34.241"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.0085 13.6792H64.721"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5996 17.4414H47.9204"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.3247 39.3754L22.5164 29.5171"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.9246 47.8334V38.9959M5.54126 35.5542V62.5917H57.8954V59.1209"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.43719 36.0503L4.14136 35.1753M38.1205 44.2753L18.3455 38.967"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6917 43.8955V62.5913"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9456 29.896V40.4835"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.4704 62.5919V52.5586H16.4204V62.5919"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9458 52.5586V62.5919"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1372 53.4629V57.5754"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.6626 53.4629V57.5754"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.6626 43.8955V48.008"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.2122 23.3618H64.5163"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.0955 28.3789H64.6038"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.3083 28.3789H48.1834"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6911 47.541H5.57031"
        stroke="#4072C8"
        strokeWidth="2.50833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ManufIcon;
